import { fireLogEvent, fireStatusUpdate, Namespace } from '@chegg/commerce-utils';

/**
 * Fire Status Update event
 * @param data
 */
export var doFireStatusUpdate = function doFireStatusUpdate(data) {
  fireStatusUpdate(data, Namespace.PAYMENT_METHODS);
};

/**
 * Fire log event
 * @param data
 */
export var doFireLogEvent = function doFireLogEvent(data) {
  fireLogEvent(data, Namespace.PAYMENT_METHODS);
};

/**
 * send rio event as a callback to host app
 * @param logObj Rio logging event
 * @returns
 */
export var sendRioEventCallback = doFireLogEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/CallbackUtils.js
// module id = 27
// module chunks = 11